import React, { useContext, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";

import { HistoricalMasiveEmployeContext } from "../../../contexts/production/HistoricalMasiveEmployeContext";
import { SecurityContext } from "../../../contexts/security/SecurityContext";
import moment from "moment";
import Pagination from "react-js-pagination";
import { FORMAT_APP } from "../../../js/constant";
import PaginationApp from "../../general/complements/PaginationApp";
const MasiveCreateRate = () => {
  const [
    { historiesRate, rowsrate, optionsLimit, metaRowRate },
    { setmetaRowRate },
  ] = useContext(HistoricalMasiveEmployeContext);
  const [{ user }, { setColorsPagination }] = useContext(SecurityContext);
  const setFieldFilter = (field, e, withTarget = true) => {
    let meta = metaRowRate.filtersLike;
    if (withTarget) {
      meta[field] = e.target.value;
    } else {
      meta[field] = e;
    }

    setmetaRowRate({ ...metaRowRate, filtersLike: meta });
  };
  useEffect(() => {
    setColorsPagination();
  }, [user.plant, metaRowRate.page, metaRowRate.page]);
  const setFieldMeta = (value, field) => {
    setmetaRowRate({ ...metaRowRate, [field]: value });
  };
  return (
    <div>
      <table className="standard-index-table container-fluid">
        <thead>
          <tr style={user.cl2}>
            <td>
              <input
                className="w-100 input-no-view-app input-search txt-center font-title "
                style={user.cl2}
                onChange={(e) => setFieldFilter("user.person:first_name", e)}
                value={metaRowRate.filtersLike["user.person:first_name"]}
                placeholder="&#xF002; Usuario"
                type="text"
              />
            </td>

            <td>Fecha</td>

            <td>Documento subido</td>

            <td title="Fecha de Ingreso" className=" d-none d-sm-block">
              Documento resultado
            </td>
          </tr>
        </thead>
        <tbody id="table-employes-index">
          {historiesRate.elements.map((history) => {
            return (
              <tr style={user.cl3} key={history.id}>
                <td>
                  {history.user.person.first_name}{" "}
                  {history.user.person.last_name}
                </td>
                <td>{moment(history.created_at).format(FORMAT_APP)}</td>
                <td>
                  {history.doc_masive_rate.length > 0 && (
                    <Link
                      style={user.cl1}
                      className="link"
                      to={`/app/general/document/${history.doc_masive_rate[0].name}`}
                    >
                      {history.doc_masive_rate[0].title}
                    </Link>
                  )}
                </td>
                <td>
                  {history.log_create_rate.length > 0 && (
                    <Link
                      style={user.cl1}
                      className="link"
                      to={`/app/general/document/${history.log_create_rate[0].name}`}
                    >
                      {history.log_create_rate[0].title}
                    </Link>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div style={{ margin: "10PX" }} className="flex justify-betwen">
        <div className="flex">
          Mostrar&nbsp;
          <select
            onChange={(e) =>
              e.target.value != metaRowRate.limit
                ? setFieldMeta(e.target.value, "limit")
                : ""
            }
            style={{ height: "22px" }}
            className="form-select form-select-sm"
            aria-label=".form-select-sm example"
          >
            {optionsLimit.map((limit, index) => {
              if (limit == metaRowRate.limit) {
                return (
                  <option key={index} selected value={limit}>
                    {limit}
                  </option>
                );
              } else {
                return (
                  <option key={index} value={limit}>
                    {limit}
                  </option>
                );
              }
            })}
          </select>
          &nbsp; registros
        </div>
        <div className="justify-end flex">
          <PaginationApp
            count={Math.ceil(rowsrate / metaRowRate.limit)}
            page={metaRowRate.page}
            func={setFieldMeta}
          />
        </div>
      </div>
    </div>
  );
};

export default MasiveCreateRate;
